"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _commonCta = require("@mmc/common-cta");
var _themeProvider = require("@mmc/theme-provider");
var _clsx = _interopRequireDefault(require("clsx"));
var _calculationForm = require("./calculation-form.prop-types");
var _calculationForm2 = _interopRequireDefault(require("./calculation-form.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var costBreakdownIdCounter = 0;
var ExtraLinks = function ExtraLinks(_ref) {
  var data = _ref.data,
    onShareDialogClick = _ref.onShareDialogClick,
    onCostsOrTaxesModalClick = _ref.onCostsOrTaxesModalClick,
    calculation = _ref.calculation,
    market = _ref.market,
    labels = _ref.labels;
  var theme = (0, _themeProvider.useTheme)();
  var commonCtaClasses = (0, _clsx["default"])(_calculationForm2["default"].ctaBtn, _calculationForm2["default"].ctaBtnMdBlock);
  var _useState = (0, _react.useState)(0),
    idCount = _useState[0],
    setIdCount = _useState[1];
  if (!calculation.reqAQuoteFormUrl && calculation.requestQuoteRedirectUrl) {
    calculation.reqAQuoteFormUrl = calculation.requestQuoteRedirectUrl;
  }
  (0, _react.useEffect)(function () {
    setIdCount(costBreakdownIdCounter);
    costBreakdownIdCounter += 1;
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (data.requestQuoteLabel || data.requestTestDrive) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculationForm2["default"].extraLinksContainer
  }, data.requestQuoteLabel && calculation.reqAQuoteFormUrl && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "request-a-quote",
    theme: theme,
    classes: [_calculationForm2["default"].ctaBtn, _calculationForm2["default"].ctaBtnMdBlock],
    data: {
      label: data.requestQuoteLabel,
      priority: 'critical',
      url: calculation.reqAQuoteFormUrl
    }
  }), data.requestTestDrive && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "request-test-drive",
    theme: theme,
    classes: commonCtaClasses,
    data: _objectSpread(_objectSpread({}, data.requestTestDrive), {}, {
      priority: 'lowIcon',
      icon: 'SteeringWheel'
    })
  })), data.shareCalculationLabel && market !== 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "share-calculation",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.shareCalculationLabel,
      priority: 'lowIcon',
      icon: 'Upload'
    },
    clickEvent: onShareDialogClick
  }), market === 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "cost-breakdown",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: labels.costBreakDownBtnLabel,
      icon: 'Calculator',
      priority: 'lowIcon',
      ctaProps: {
        id: "cost-breakdown-" + idCount
      }
    },
    clickEvent: onCostsOrTaxesModalClick
  }), data.seeAllOffersLabel && calculation.viewSpecialOffersLink && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "offers",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.seeAllOffersLabel,
      priority: 'lowIcon',
      icon: 'AnnualReport',
      url: calculation.viewSpecialOffersLink
    }
  }), data.buildAndPriceLabel && market === 'ca' && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    "data-testid": "build-and-price",
    theme: theme,
    classes: commonCtaClasses,
    data: {
      label: data.buildAndPriceLabel,
      priority: 'critical',
      icon: 'AnnualReport',
      url: calculation.buildAndPriceUrl
    }
  }));
};
var _default = /*#__PURE__*/_react["default"].memo(ExtraLinks);
exports["default"] = _default;